import { merge } from '../../helper';

import type { IModalConfig } from './types';
import { create, type TypeBuildReturn } from './create';
import * as exUtils from './utils';

// ----------------------------------------------------------------------------

export interface IStartConfig extends IModalConfig {
    show?: boolean;
}

// ----------------------------------------------------------------------------

function start(config: IStartConfig = {}): TypeBuildReturn {
    const defConfig: IStartConfig = {
        show: true,
    };
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (modal)
    const modal = create({
        merge: defConfig,
        container: {
            parent: document.body,
        },
    });

    // If using show
    if (defConfig.show === true) {
        exUtils.show(modal.element);
    }

    // ------------------------------------------------------------------------

    // Return
    return modal;
}

// ----------------------------------------------------------------------------

export { start };
